/* eslint-disable */
import { produce } from "immer";
import {
  CHANGE_INVESTMENT_FETCH_FAILURE,
  CHANGE_INVESTMENT_FETCH_SUCCESS,
  CHANGE_INVESTMENT_FETCH_START,
} from "../actions/types";

const changeInvestment = (
  state = {
    changeInvestmentFetching: false,
    changeInvestmentData: [],
    changeInvestmentError: null,
  },
  action,
) => {
  switch (action.type) {
    case CHANGE_INVESTMENT_FETCH_START:
      return produce(state, (draft) => {
        draft.fetching = true;
      });
    case CHANGE_INVESTMENT_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.fetching = true;
        draft.data = action.data;
        draft.fetching = false;
      });
    case CHANGE_INVESTMENT_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.fetching = false;
        draft.error = action.error;
      });
    default:
      return state;
  }
};

export default changeInvestment;
